export enum EntityStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Deleted = 'DELETED',
  Active_Inactive = 'ACTIVE,INACTIVE',
  Active_Inactive_Deleted = 'ACTIVE,INACTIVE,DELETED',
  ActivationPending = 'ACTIVATION_PENDING',
  OnBoardingError = 'ONBOARDING_ERROR',
  InvalidError = 'INVALID_ERROR',
}
